/**
 * Shared secret for admin SPA → BFF in local dev (must match BFF `BFF_INTERNAL_SERVICE_TOKEN`).
 * Same default as frontend-nextjs `DEV_FALLBACK_BFF_INTERNAL_TOKEN`.
 */
export const DEV_FALLBACK_BFF_INTERNAL_TOKEN = 'dev-bff-internal-token-change-me';

/** Headers for trusted admin → BFF calls (dev fallback or explicit env at build time). */
export function getBffInternalAuthHeaders() {
  const fromEnv =
    typeof import.meta !== 'undefined' && import.meta.env?.VITE_BFF_INTERNAL_SERVICE_TOKEN
      ? String(import.meta.env.VITE_BFF_INTERNAL_SERVICE_TOKEN).trim()
      : '';
  const token =
    fromEnv ||
    (typeof import.meta !== 'undefined' && import.meta.env?.DEV
      ? DEV_FALLBACK_BFF_INTERNAL_TOKEN
      : '');
  if (!token) return {};
  return { 'X-BFF-Internal-Token': token };
}
